angular
    .module('webcomm')
    .directive('touchEnd',
        function () {
            return function (scope, element, attr) {

                element.on('touchend', function (event) {
                    scope.$apply(function () {
                        scope.$eval(attr.touchEnd);
                    });
                });
            };
        })
    .directive('touchStart', ['Modernizr',
        function (Modernizr) {
            return function (scope, element, attr) {

                element[0].addEventListener('touchstart', function (event) {
                    scope.$apply(function () {
                        scope.$eval(attr.touchStart);
                    });
                }, Modernizr.passiveeventlisteners ? {passive: true} : false);
            };
        }]);
